import React, { useEffect } from "react";
import { CounterContainer } from "./style";
const Counter = ({ reSendCode }) => {
  const [count, setCount] = React.useState(180);
  const decrement = () => setCount(count - 1);
  useEffect(() => {
    if (count !== 0) {
      const interval = setTimeout(decrement, 1000);
      return () => clearTimeout(interval);
    }
  });
  return (
    <CounterContainer>
      {count ? (
        <>
          درخواست ارسال مجدد بعد از <span>{count}</span> ثانیه
        </>
      ) : (
        <div
          className="resend"
          onClick={() => {
            setCount(180);
            reSendCode();
          }}
        >
          ارسال مجدد
        </div>
      )}
    </CounterContainer>
  );
};
export default React.memo(Counter);
